// extracted by mini-css-extract-plugin
export var wordContainer = "_rk-0";